<template>
    <div id="invite_detail">
        <div class="bread">
            <el-breadcrumb>
                <el-breadcrumb-item :to="{path: '/course_list',query:{type:bm_type}}">直播列表</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path: '/course',query:{liveId:livingId,type:bm_type,livetype:livetype}}">
                    组别数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{path: '/course_detail', query:{liveId:livingId,bmbm:bmbm,type:bm_type,date:JSON.stringify(date),livetype:livetype}}">
                    组内数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    员工数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})
                </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="back" @click="backPage()"> 返回</div>
        </div>
        <div class="main">
            <div class="courselist-box">
                <div class="titlebox">
                    <div class="title">员工数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})</div>
                    <div class="notice">
                        <dlxlsx :sheet="line.down.sheet" :head="line.down.head" :data="line.down.list"></dlxlsx>
                        <span class="refresh" @click="getList">刷新</span>
                    </div>
                </div>
                <div class="string"></div>
                <div class="navs">
                    <el-form class="course_search_form" ref="course_search_form" size="large">
                        <el-form-item v-if="bm_type || bm_type!=''" label="资源进线时间">
                            <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getList" format="YYYY-MM-DD" value-format="YYYY-MM-DD">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="navs" v-if="bm_type=='_1'">
                    <el-form class="course_search_form" ref="course_search_form" size="large">
                        <el-form-item label="MCN列表:" style="margin-left: 32px;">
                            <el-select clearable v-model="search.mcnName" @clear="mcnClear" @change="mcnChange">
                                <el-option v-for="(item, index) in mcn" :key="index" :label="item.mcn_name" :value="item.mcn_name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="老师:" style="margin-left: 32px;">
                            <el-select clearable v-model="search.teacherId" @clear="teacherClear" @change="teacherChange">
                                <el-option v-for="(item, index) in teacher" :key="index" :label="item.refferid_name" :value="item.refferid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-left: 32px;color:red;">
                            <span>{{seltxt}}</span>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="list">
                    <el-table v-loading="loading" element-loading-text="查找数据可能会花费较长时间，请耐心等待..." :data="tableData" style="width: 98%;margin: 0 auto;height: 100%;overflow: auto;" :height="tableHeight" :header-cell-style="{backgroundColor: '#FAFAFA'}" :row-style="{height: '26px'}" :cell-style="{padding: '0'}">
                        <el-table-column label="序号" width="80" align="center" fixed="left">
                            <template #default="scope">
                                <span>{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="客户昵称" min-width="180" show-overflow-tooltip prop="wx_nickname" align="center" fixed="left">
                            <template #default="scope">
                                <span :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{ scope.row.wx_nickname }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="客户头像" width="80" prop="img" align="center" fixed="left">
                            <template #default="scope">
                                <img :src="scope.row.wx_avatar" :style="{width: '40px',height: '40px'}" />
                            </template>
                        </el-table-column>
                        <!-- <el-table-column v-if="livetype==''" sortable label="是否新客户" width="160" prop="user_x" align="center">
              <template #default="scope">
                <span :style="{color:scope.row.user_x == '是' ? '#00d708' :'#606266'}">{{scope.row.user_x}}</span>
              </template>
            </el-table-column> -->

                        <el-table-column v-if="bm_type==''" sortable width="160" prop="user_x" align="center">
                            <template #header>
                                <el-popover placement="top" :width="260" trigger="hover">
                                    <template #reference>
                                        <span class="remark-header">
                                            备注<span class="remark-warning">!</span>
                                        </span>
                                    </template>
                                    <div class="remark-popover-text">此备注是用户最新加的业务备注，可能不是你的备注，仅用于确认用户身份</div>
                                </el-popover>
                            </template>
                            <template #default="scope">
                                <span :style="{color:scope.row.user_x == '是' ? '#00d708' :'#606266'}">{{scope.row.user_x}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column sortable label="是否退出" width="160" prop="out" align="center">
                            <template #default="scope">
                                <span :style="{color:scope.row.out == 1 ? 'red' :'#333333'}">{{scope.row.out == 1 ? "是" : "否"}}</span>
                            </template>
                        </el-table-column>
                        <template v-if="bm_type==''">
                            <el-table-column sortable label="直播观看时长" width="180" prop="his_learning_time" align="center">
                                <template #default="scope">
                                    <!-- <span v-if="livetype=='all'" :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{Math.round(scope.row.his_learn_time / 60)}}分钟</span>
                  <span v-else-if="livetype=='replay'" :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{Math.round(scope.row.his_learned_time / 60)}}分钟</span>
                  <span v-else-if="livetype=='live'" :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{Math.round(scope.row.his_learning_time / 60)}}分钟</span>
                  <span v-else :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{Math.round(scope.row.his_learning_time / 60)}}分钟</span> -->
                                    <span :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{formatDuration(scope.row.his_learning_time)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column sortable label="回看时长" width="180" prop="his_learned_time" align="center">
                                <template #default="scope">
                                    <span :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{formatDuration(scope.row.his_learned_time)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column sortable label="累计观看时长" width="180" prop="his_learn_time" align="center">
                                <template #default="scope">
                                    <span :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{formatDuration(scope.row.his_learn_time)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column sortable label="第一次观看时间" width="190" prop="first_min_time" align="center">
                                <template #default="scope">
                                    <span :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{ scope.row.first_min_time }}</span>
                                </template>
                            </el-table-column>
                        </template>
                        <template v-else>
                            <el-table-column sortable label="直播观看时长" width="180" prop="his_learning_time" align="center">
                                <template #default="scope">
                                    <span v-if="livetype=='all'" :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{formatDuration(scope.row.his_learn_time)}}</span>
                                    <span v-if="livetype=='replay'" :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{formatDuration(scope.row.his_learned_time)}}</span>
                                    <span v-if="livetype=='live'" :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{formatDuration(scope.row.his_learning_time)}}</span>
                                </template>
                            </el-table-column>
                        </template>
                        <el-table-column sortable label="首次进入时间" width="190" prop="first_in_time" align="center">
                            <template #default="scope">
                                <span :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{ scope.row.first_in_time }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable label="最近进入时间" width="190" prop="last_in_time" align="center">
                            <template #default="scope">
                                <span :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}">{{ scope.row.last_in_time }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable label="评论数" width="100" prop="comment_num" align="center" fixed="right">
                            <template #header>
                                <el-popover placement="top" :width="220" trigger="hover">
                                    <template #reference>
                                        <span class="remark-header">
                                            评论数<span class="remark-warning">!</span>
                                        </span>
                                    </template>
                                    <div class="remark-popover-text">仅直播时评论数据</div>
                                </el-popover>
                            </template>
                            <template #default="scope">
                                <span v-if="!scope.row.comment_num || scope.row.comment_num == 0" :style="{color:scope.row.out == 1 ? '#999999' :'#333333'}" >{{ scope.row.comment_num || 0 }}</span>
                                <span v-else class="caozuo" @click="gotoChatRecords(scope.row)">{{ scope.row.comment_num }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center" fixed="right" v-if="e_id==''||e_id=='yhid_sy1_qt'">
                            <template #default="scope">
                                <el-button size="small" type="primary" @click="openSettingDialog(scope.row)">
                                    设置
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <!-- 设置对话框 -->
        <el-dialog v-model="settingDialogVisible" title="用户设置" width="500px" :close-on-click-modal="false">
            <el-form :model="settingForm" label-width="80px" ref="settingFormRef">
                <el-form-item label="用户昵称">
                    <el-input v-model="settingForm.wx_nickname" disabled />
                </el-form-item>
                <el-form-item label="备注" prop="remark" :rules="[{ required: true, message: '请输入备注', trigger: 'blur' }]">
                    <el-input v-model="settingForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息" maxlength="255" show-word-limit />
                </el-form-item>
                <el-form-item label="用户类型" prop="userType" :rules="[{ required: true, message: '请选择用户类型', trigger: 'change' }]">
                    <el-select v-model="settingForm.userType" placeholder="请选择用户类型" style="width: 100%">
                        <el-option label="内部用户" :value="1" />
                        <el-option label="合作用户" :value="2" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="settingDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitSetting" :loading="submitLoading">
                        提交
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import './assets/less/index.less'
import common_m from '@/common/model'
import model from './model/model'
import moment from 'moment'
import date from '@/common/date'
import dlxlsx from '@/components/dlXlsx_cs/index'
var that = null
export default {
    components: {
        dlxlsx,
    },
    data() {
        that = this
        return {
            loading: true,
            navIndex: 0,
            userInfo: null,
            tableHeight: 500,
            tableData: [],
            activeIndex: 0,
            livingId: that.$route.query.liveId || '0', //标题
            bmbm: that.$route.query.bmbm || '', //标题
            e_id: that.$route.query.e_id || '', //标题
            type: that.$route.query.type || 3, //标题
            bm_type: that.$route.query.bm_type || '', //部门类型
            date: JSON.parse(that.$route.query.date) || null, //资源进线时间
            livetype: that.$route.query.livetype || '', //直播数据类型
            search: {
                mcnName: null,
                teacherId: null,
            },
            mcn: [],
            teacher: [],
            seltxt: '',

            line: {
                down: {
                    sheet: ['员工数据'],
                    head: [],
                    list: [],
                },
            },
            settingDialogVisible: false,
            settingForm: {
                wx_nickname: '',
                unionid: '',
                remark: '',
                userType: null,
            },
            submitLoading: false,
        }
    },
    mounted() {
        // 初始化前判断登录态缓存，不存在则跳回列表页
        if (!localStorage.getItem('fallback_ywy_user')) {
            that.$router.replace('/course_list')
            return
        }
        that.$nextTick(() => {
            that.tableHeight = document.querySelector('.list').clientHeight - 10
        })
        that.init()
    },
    methods: {
        /**
         * 格式化时长显示
         * @param {number} seconds - 秒数
         * @returns {string} 格式化后的时长字符串
         */
        formatDuration(seconds) {
            if (!seconds || seconds < 0) {
                return '0秒'
            }
            if (seconds < 60) {
                return seconds + '秒'
            } else {
                return Math.round(seconds / 60) + '分钟'
            }
        },
        
        init() {
            if (that.bm_type == '_1') {
                that.getMCN(1)
            }
            that.getList()
            // common_m.getUserInfoWithAccountFallback().then(
            //     function (res) {
            //         that.currentUserInfo = res
                    
            //     },
            //     function (err) {
            //         console.log(err)
            //         that.loading = false
            //         that.currentUserInfo = null
            //         that.tableData = []
            //     }
            // )
        },
        backPage() {
            window.history.back()
        },
        getList() {
            // if (!that.currentUserInfo || !that.currentUserInfo.yhid) {
            //     that.loading = false
            //     that.tableData = []
            //     return
            // }
            that.seltxt = ''
            that.loading = true
            let params = {
                livingid: that.livingId,
                bmbm: that.e_id,
                type: parseInt(that.type),
                pageIndex: 1,
                pageSize: 50,
            }
            if (that.bm_type && that.bm_type != '' && that.date != null) {
                params.begintime = that.date[0]
                params.endtime = that.date[1]
            }
            if (that.bm_type == '_1') {
                if (that.search.teacherId != null) {
                    params.refferid = that.search.teacherId
                }
            }
            model
                .get_e_live_bm(params, that.bm_type, that.livetype, that.bmbm)
                .then(
                    function (res) {
                        that.loading = false
                        if (res.code == 0) {
                            // that.tableData = res.list.map(item => {
                            //   // 返回一个新对象，将指定字段更新为新的值
                            //   return { ...item, out: 0 };
                            // });
                            that.tableData = res.list
                            // that.page.total = res.total;
                            if (res.list && res.list.length > 0) {
                                that.setExcelDataList(that.tableData)
                            }
                        } else {
                            that.tableData = []
                        }
                    },
                    function (err) {
                        console.log(err)
                        that.loading = false
                        that.tableData = []
                    }
                )
        },
        setExcelDataList(data) {
            let ndata = JSON.parse(JSON.stringify(data))
            console.log(ndata)
            if (that.livetype == '') {
                that.line.down.head = [
                    '客户昵称',
                    '客户头像',
                    '是否新客户',
                    '是否退出',
                    '直播观看时长',
                    '回看时长',
                    '累计观看时长',
                    '第一次观看时间',
                    '首次进入时间',
                    '最近进入时间',
                    '评论数',
                ]
                that.line.down.list = ndata.map((v) => ({
                    wx_nickname: v.wx_nickname,
                    wx_avatar: v.wx_avatar,
                    user_x: v.user_x,
                    out: v.out == 1 ? '是' : '否',
                    his_learning_time: that.formatDuration(v.his_learning_time),
                    his_learned_time: that.formatDuration(v.his_learned_time),
                    his_learn_time: that.formatDuration(v.his_learn_time),
                    first_min_time: v.first_min_time,
                    first_in_time: v.first_in_time,
                    last_in_time: v.last_in_time,
                    comment_num: v.comment_num,
                }))
            } else {
                that.line.down.head = [
                    '客户昵称',
                    '客户头像',
                    '是否退出',
                    '直播观看时长',
                    '首次进入时间',
                    '最近进入时间',
                    '评论数',
                ]
                that.line.down.list = ndata.map((v) => ({
                    wx_nickname: v.wx_nickname,
                    wx_avatar: v.wx_avatar,
                    out: v.out == 1 ? '是' : '否',
                    his_learning_time: that.formatDuration(
                        that.livetype == 'all'
                            ? v.his_learn_time
                            : that.livetype == 'replay'
                            ? v.his_learned_time
                            : v.his_learning_time
                    ),
                    first_in_time: v.first_in_time,
                    last_in_time: v.last_in_time,
                    comment_num: v.comment_num,
                }))
            }
        },

        /**
         * 获取MCN列表
         */
        getMCN(id) {
            model.getMCN(id).then((res) => {
                if (res.code == 0) {
                    that.mcn = res.data
                }
            })
        },

        /**
         * MCN清空处理
         */
        mcnClear() {
            that.loading = true
            that.search.mcnName = null
            that.search.teacherId = null
            that.getList()
        },

        /**
         * MCN变化处理
         */
        mcnChange() {
            if (that.search.mcnName) {
                that.search.teacherId = null
                that.teacher = []
                that.getTeacher(that.search.mcnName)
            }
        },

        /**
         * 获取老师列表
         */
        getTeacher(name) {
            model.getTeacher(name).then((res) => {
                if (res.code == 0) {
                    that.teacher = res.data
                }
            })
        },

        /**
         * 老师清空处理
         */
        teacherClear() {
            that.loading = true
            that.search.teacherId = null
            that.getList()
        },

        /**
         * 老师变化处理
         */
        teacherChange() {
            // 判断是否有选择时间
            if (that.date == null) {
                that.seltxt = 'mcn搜索需要选择时间'
            } else {
                that.getList()
            }
        },

        handleChange(index) {
            if (that.loading) {
                return
            }
            that.navIndex = index
            that.getList()
        },

        /**
         * 跳转到用户聊天记录页面
         */
        gotoChatRecords(row) {
            // 跳转到聊天记录页，URL 带上 unionid、livingid 和 from=info
            let unionid = row.wx_union_id || row.unionid || ''
            let livingid = that.livingId || ''
            if (!unionid) {
                that.$message.warning('该用户没有 unionid，无法查看聊天记录')
                return
            }
            if (!livingid) {
                that.$message.warning('缺少直播ID，无法查看聊天记录')
                return
            }
            // 构造返回所需的 query（保留原页面的入参），并附加 from=info
            const backQuery = Object.assign({}, that.$route.query, {
                from: 'info'
            })
            let routeUrl = that.$router.resolve({
                path: '/chat_records',
                query: {
                    unionid: unionid,
                    livingid: livingid,
                    ...backQuery
                }
            })
            window.open(routeUrl.href, '_blank')
        },

        /**
         * 打开设置对话框
         */
        openSettingDialog(row) {
            this.settingForm = {
                wx_nickname: row.wx_nickname,
                unionid: row.wx_union_id,
                remark: '',
                userType: null,
            }
            this.settingDialogVisible = true
            this.$nextTick(() => {
                this.$refs.settingFormRef &&
                    this.$refs.settingFormRef.clearValidate()
            })
        },

        /**
         * 提交设置
         */
        submitSetting() {
            this.$refs.settingFormRef.validate((valid) => {
                if (valid) {
                    this.submitLoading = true

                    // 准备请求参数
                    const params = {
                        unionid: this.settingForm.unionid,
                        remark: this.settingForm.remark,
                        userType: this.settingForm.userType,
                    }

                    // 调用后端接口（接口暂未实现，这里只是预留）
                    model
                        .updateUserSetting(params)
                        .then((res) => {
                            if (res.code === 0) {
                                this.$message.success('设置成功')
                                this.settingDialogVisible = false
                                // 可以刷新列表或更新本地数据
                                this.getList()
                            } else {
                                this.$message.error(res.msg || '设置失败')
                            }
                        })
                        .catch((err) => {
                            console.error('设置失败:', err)
                            this.$message.error('设置失败，请稍后重试')
                        })
                        .finally(() => {
                            this.submitLoading = false
                        })
                }
            })
        },
    },
}
</script>

<style scoped>
.remark-header {
    display: inline-flex;
    align-items: center;
    cursor: help;
}
.remark-warning {
    display: inline-block;
    margin-left: 4px;
    color: #E6A23C;
    font-weight: bold;
    cursor: help;
    font-size: 14px;
    line-height: 1;
}
.remark-popover-text {
    font-size: 13px;
    color: #606266;
    line-height: 1.6;
    text-align: left;
}
</style>
